(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/product-settings.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/product-settings.js');
svs = svs || {};

(function(svs) {
  'use strict';


  svs.tt = svs.tt || {};

  var Product = function(
    productType,
    productName,
    productTemplateName,
    urlName,
    allowFiltering
  ) {
    this.productType = productType;
    this.productName = productName;
    this.productTemplateName = productTemplateName;
    this.urlName = urlName;
    this.allowFiltering = allowFiltering;
    this.offset = 0;
    this.count = 100;
  };

  svs.tt.productSettings = {};
  svs.tt.productSettings.stryktipset = new Product(
    'stryktipset',
    'Stryktipset',
    'tipsen',
    'stryktipset',
    false
  );
  svs.tt.productSettings.europatipset = new Product(
    'europatipset',
    'Europatipset',
    'tipsen',
    'europatipset',
    false
  );
  svs.tt.productSettings.topptipset = new Product(
    'topptipset',
    'Topptipset',
    'tipsen',
    'topptipset',
    false
  );
  svs.tt.productSettings.powerplay = new Product(
    'powerplay',
    'powerplay',
    'tipsen',
    'powerplay',
    false
  );
  svs.tt.productSettings.fulltraff = new Product(
    'fulltraff',
    'Fullträff',
    'tipsen',
    'fulltraff',
    false
  );
  svs.tt.productSettings.maltipset = new Product(
    'maltipset',
    'Måltipset',
    'tipsen',
    'maltipset',
    false
  );
  svs.tt.productSettings.oddset = new Product(
    'oddsetlist',
    'Oddset',
    'oddset',
    'oddset',
    true
  );
  svs.tt.productSettings.challenge = new Product(
    'challenge',
    'Challenge',
    'tipsen',
    'challenge',
    true
  );
  svs.tt.productSettings.bomben = new Product(
    'bomben',
    'Bomben',
    'bomben',
    'bomben',
    true
  );
  svs.tt.productSettings.matchen = new Product(
    'matchen',
    'Matchen',
    'bomben',
    'matchen',
    true
  );

  svs.tt.productSettings.start = new Product(
    'start',
    'start',
    'start',
    'start',
    false
  );

  svs.tt.defaultProduct = 'start';
})(svs);


 })(window);